import { Button, Icon, Text } from '@lounge-fe/ui-kit'
import { SignupSuccessContentProps } from './types'

export const SignupSuccessContent = ({
  promo,
  body,
  disclaimer,
  buttonText,
  buttonUrl,
}: SignupSuccessContentProps) => {
  const copy = (text: string) => navigator.clipboard.writeText(text)

  return (
    <div className="grid gap-4 text-left">
      {promo && (
        <Button
          variant="ghost"
          className="mb-4"
          startIcon={<Icon.Copy />}
          onClick={() => copy(promo)}
        >
          {promo}
        </Button>
      )}

      {body && (
        <div
          dangerouslySetInnerHTML={{
            __html: body,
          }}
        />
      )}

      {disclaimer && (
        <Text variant="body-xs" className="text-subtle">
          {disclaimer}
        </Text>
      )}

      {buttonText && (
        <Button variant="solid" className="w-full mt-4" href={buttonUrl}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}
